import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

/** A search mode replaces the action list with results from /search. */
export type SearchMode = 'advertisers' | 'lineItems' | 'orders' | 'creatives'

/** Modes that list what is already loaded, rather than querying the API. */
export const PICKER_MODES = ['networks', 'pages', 'reports'] as const
export type PickerMode = (typeof PICKER_MODES)[number]

export type PaletteMode = SearchMode | PickerMode

export interface SearchModeConfig {
  /** Object type as the search API names it. */
  type: string
  icon: LucideIcon
  path: (id: string) => string
  /** i18n key suffix under `commandPalette`. */
  key: string
  /**
   * Optional second line under each result. The ids of a whole result page are
   * resolved in one follow-up request, keyed by id.
   */
  loadSubtitles?: (ids: string[]) => Promise<Record<string, string>>
}

/**
 * Actions are shown under a heading, in this order. The heading text comes from
 * `commandPalette.groups.<group>`.
 */
export const ACTION_GROUPS = [
  'navigation',
  'search',
  'searchAllNetworks',
  'modules',
  'networks',
  'preferences',
] as const
export type ActionGroup = (typeof ACTION_GROUPS)[number]

export interface CommandAction {
  id: string
  label: string
  group: ActionGroup
  /** Extra words that should also match the filter, e.g. an alias. */
  keywords?: string
  icon?: ReactNode
  /** Switch the palette into a search or picker mode instead of running. */
  mode?: PaletteMode
  run?: () => void
}
